module.exports = __webpack_public_path__ + "static/media/close-menu.ec3813a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close-menu.svg
// module id = 373
// module chunks = 0